var $ = require("./jquery-mask.js");

$('.phone_mask :input').mask('(00) 0000-0000', {placeholder: "(__) ____-____"}); 
$('.cpf_mask :input').mask('000.000.000-00', {placeholder: "___.___.___-__"}); 
$('.cnpj_mask :input').mask('00.000.000/0000-00', {placeholder: "__.___.___/____-__"}); 
$('.cep_mask :input').mask('00000-000', {placeholder: "_____-___", clearIfNotMatch: true}); 
$('.money_mask :input').mask('000.000.000.000.000,00', {reverse: true});


// WEBPACK FOOTER //
// ./src/helpers/MaskDefinitions.js